"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Eip1993Factories = void 0;
var configurationError_1 = require("../errors/configurationError");
var resolutionError_1 = __importStar(require("../errors/resolutionError"));
exports.Eip1993Factories = {
  fromWeb3Version0Provider: fromWeb3Version0Provider,
  fromWeb3Version1Provider: fromWeb3Version1Provider,
  fromEthersProvider: fromEthersProvider,
  fromZilliqaProvider: fromZilliqaProvider
};
/**
 * Create a Provider instance from web3 0.x version provider
 * @param provider - an 0.x version provider from web3 ( must implement sendAsync(payload, callback) )
 * @see https://github.com/ethereum/web3.js/blob/0.20.7/lib/web3/httpprovider.js#L116
 */
function fromWeb3Version0Provider(provider) {
  if (provider.sendAsync === undefined) {
    throw new configurationError_1.ConfigurationError(configurationError_1.ConfigurationErrorCode.IncorrectProvider);
  }
  return {
    request: function (request) {
      return new Promise(function (resolve, reject) {
        provider.sendAsync({
          jsonrpc: '2.0',
          method: request.method,
          params: wrapArray(request.params),
          id: 1
        }, function (error, result) {
          if (error) {
            reject(error);
          }
          if (result.error) {
            reject(new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
              providerMessage: result.error
            }));
          }
          resolve(result.result);
        });
      });
    }
  };
}
/**
 * Create a Provider instance from web3 1.x version provider
 * @param provider - an 1.x version provider from web3 ( must implement send(payload, callback) )
 * @see https://github.com/ethereum/web3.js/blob/1.x/packages/web3-core-helpers/types/index.d.ts#L165
 * @see https://github.com/ethereum/web3.js/blob/1.x/packages/web3-providers-http/src/index.js#L95
 */
function fromWeb3Version1Provider(provider) {
  if (provider.send === undefined) {
    throw new configurationError_1.ConfigurationError(configurationError_1.ConfigurationErrorCode.IncorrectProvider);
  }
  return {
    request: function (request) {
      return new Promise(function (resolve, reject) {
        provider.send({
          jsonrpc: '2.0',
          method: request.method,
          params: wrapArray(request.params),
          id: 1
        }, function (error, result) {
          if (error) {
            reject(error);
          }
          if (result.error) {
            reject(new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
              providerMessage: result.error
            }));
          }
          resolve(result.result);
        });
      });
    }
  };
}
/**
 * Creates a Provider instance from a provider that implements Ethers Provider#call interface.
 * This wrapper support only `eth_call` method for now, which is enough for all the current Resolution functionality
 * @param provider - provider object
 * @see https://github.com/ethers-io/ethers.js/blob/v4-legacy/providers/abstract-provider.d.ts#L91
 * @see https://github.com/ethers-io/ethers.js/blob/v5.0.4/packages/abstract-provider/src.ts/index.ts#L224
 * @see https://docs.ethers.io/ethers.js/v5-beta/api-providers.html#jsonrpcprovider-inherits-from-provider
 * @see https://github.com/ethers-io/ethers.js/blob/master/packages/providers/src.ts/json-rpc-provider.ts
 */
function fromEthersProvider(provider) {
  var _this = this;
  if (provider.call === undefined) {
    throw new configurationError_1.ConfigurationError(configurationError_1.ConfigurationErrorCode.IncorrectProvider);
  }
  return {
    request: function (request) {
      return __awaiter(_this, void 0, void 0, function () {
        var _a, error_1;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 7,, 8]);
              _a = request.method;
              switch (_a) {
                case 'eth_call':
                  return [3 /*break*/, 1];
                case 'eth_getLogs':
                  return [3 /*break*/, 3];
              }
              return [3 /*break*/, 5];
            case 1:
              return [4 /*yield*/, provider.call(request.params[0])];
            case 2:
              return [2 /*return*/, _b.sent()];
            case 3:
              return [4 /*yield*/, provider.getLogs(request.params[0])];
            case 4:
              return [2 /*return*/, _b.sent()];
            case 5:
              throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                providerMessage: "Unsupported provider method ".concat(request.method)
              });
            case 6:
              return [3 /*break*/, 8];
            case 7:
              error_1 = _b.sent();
              throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                providerMessage: error_1.message
              });
            case 8:
              return [2 /*return*/];
          }
        });
      });
    }
  };
}
/**
 * Creates a Provider instance from @zilliqa-js/core Provider
 * @param provider - provider object
 */
function fromZilliqaProvider(provider) {
  var _this = this;
  if (provider.middleware === undefined || provider.send === undefined) {
    throw new configurationError_1.ConfigurationError(configurationError_1.ConfigurationErrorCode.IncorrectProvider);
  }
  return {
    request: function (request) {
      return __awaiter(_this, void 0, void 0, function () {
        var resp, error_2;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 2,, 3]);
              return [4 /*yield*/, provider.send.apply(provider, __spreadArray([request.method], request.params || [], false))];
            case 1:
              resp = _a.sent();
              if (resp.error) {
                throw new Error(resp.error.message);
              }
              return [2 /*return*/, resp.result];
            case 2:
              error_2 = _a.sent();
              throw new resolutionError_1.default(resolutionError_1.ResolutionErrorCode.ServiceProviderError, {
                providerMessage: error_2.message
              });
            case 3:
              return [2 /*return*/];
          }
        });
      });
    }
  };
}
function wrapArray(params) {
  if (params === void 0) {
    params = [];
  }
  return params instanceof Array ? params : [params];
}